// version-2-
import React, { useState, useEffect } from 'react';
import {
    Box,
    // Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    MenuItem
} from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import FormModalLoanReadiness from './FormModalLoanReadiness';

const initialFormData = {
    "nResourceInstanceId": "",
    "Net Profit Margin": '',
    "Existing Loan - (if any Amount, Type and Bank)": '',
    "Type of Bank Account": '',
    "Financial Reports(ITR, B/S)": '',
    "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": '',
    "Credit Score (CIBIL)": '',
    "Quotation Documents": '',
    "Guarantor details": '',
    "Collateral": '',
    "Receivable": '',
    "Payables": '',
    "Loan Amount Required": '',
    "Required Type of Loan(Term Loan/Cash Credit/ Composite)": '',
    "Loan Purpose ( Mention distribution if composite)": '',
    "Loan Application status": '',
    "Application status reasoning": '',
    "Services Availed(BLRP phase I / BLRP phase II )": '',
    "Key Recommendations": '',
    "Learnings": '',
    "Challenges": '',
    "BLRP phase I / BLRP phase II report links": "",
    "Product Catalog Links": ""
};

export default function PersonaDetailBusinessLoanReadinessTab({
    value,
    index,
    title,
    userLoanReadinessPersonaDetails,
    handleSubmitPersonaDetails,
    isPersonaLoading,
    isPersonaFormOpen,
    setIsPersonaFormOpen,
    selectedResourceInstanceId,
    handleFormCancel,
    setIsFormOpen,
    isFormOpen,
    uniqueLoandReadinessInstanceId,
    handleUpdatePersonaDetail,
    loanReadinessAlreadyFilledPersonaInstanceId,
    resourcesDetails,
    isTestimonialScreen
}) {
    // const [isFormOpen, setIsFormOpen] = useState(false);
    const [formData, setFormData] = useState(initialFormData);

    const [isEdit, setIsEdit] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [loanReadinessResourcesOfUser, setLoanReadinessResourcesOfUser] = useState([])
    const [leftResourcesForAddingPersona, setLeftResourcesForAddingPersona] = useState([])
    const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);

    // useEffect to use the resoyurces availed by the user, here uson it for disabling of the add persona details button, if there isnt any for that category
    useEffect(() => {
        if (resourcesDetails?.LoanReadiness) {
            setLoanReadinessResourcesOfUser(resourcesDetails.LoanReadiness);

            let allLoanReadiness = resourcesDetails?.LoanReadiness;
            console.log(allLoanReadiness, ">>>>>allLoanReadiness")
            let fillingDefaultDataInPersonaDetails = allLoanReadiness.map((resourceObj) => {
                // checking if persona details exist for the instanceId if exists spread it with resource details and if not set default empty keys
                let findPersonaForInstanceId = userLoanReadinessPersonaDetails?.find((personaObj) => personaObj?.nResourceInstanceId == resourceObj?.nResourceInstanceId);
                console.log(findPersonaForInstanceId, ">>>>findPersonaForInstanceId in loanReadiness");

                if (findPersonaForInstanceId) {
                    return {
                        ...findPersonaForInstanceId,
                        ...resourceObj,
                        "Product Catalog Links": resourceObj["catalogueUrl"] ? resourceObj["catalogueUrl"] : "",
                        "isAlreadyPersonaExisting": true, // if persona already existitng then flag for all persona to show edit button
                    }
                } else {
                    return {
                        "nResourceInstanceId": "",
                        "Net Profit Margin": '',
                        "Existing Loan - (if any Amount, Type and Bank)": '',
                        "Type of Bank Account": '',
                        "Financial Reports(ITR, B/S)": '',
                        "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": '',
                        "Credit Score (CIBIL)": '',
                        "Quotation Documents": '',
                        "Guarantor details": '',
                        "Collateral": '',
                        "Receivable": '',
                        "Payables": '',
                        "Loan Amount Required": '',
                        "Required Type of Loan(Term Loan/Cash Credit/ Composite)": '',
                        "Loan Purpose ( Mention distribution if composite)": '',
                        "Loan Application status": '',
                        "Application status reasoning": '',
                        "Services Availed(BLRP phase I / BLRP phase II )": '',
                        "Key Recommendations": '',
                        "Learnings": '',
                        "Challenges": '',
                        "BLRP phase I / BLRP phase II report links": "",
                        "Product Catalog Links": resourceObj["sCatalogueUrl"] ? resourceObj["sCatalogueUrl"] : "",
                        "isAlreadyPersonaExisting": false, // if persona not already existitng then flag for all persona to show add button
                        ...resourceObj,
                    }
                }
            })

            setAllResourcePersonaDetails([...fillingDefaultDataInPersonaDetails])

            console.log(userLoanReadinessPersonaDetails, ">>>>userLoanReadinessPersonaDetails in loan readiness useEffect")
            console.log(uniqueLoandReadinessInstanceId, ">>>>uniqueLoandReadinessInstanceId");

            const alreadyFilledPersonaResourceIds = userLoanReadinessPersonaDetails?.map((obj) => {
                const { nResourceInstanceId } = obj;
                return nResourceInstanceId;
            })
            console.log(alreadyFilledPersonaResourceIds, ">>>alreadyFilledPersonaResourceIds loan readiness");

            if (alreadyFilledPersonaResourceIds) {
                const personaDetailResourceAddingLeft = uniqueLoandReadinessInstanceId?.filter((resourceId) => !alreadyFilledPersonaResourceIds.includes(resourceId))
                console.log(personaDetailResourceAddingLeft, ">>>>personaDetailResourceAddingLeft");
                setLeftResourcesForAddingPersona(personaDetailResourceAddingLeft);
            }
        } else {
            setLoanReadinessResourcesOfUser([]);
        }
        // setLoading(false);
    }, [resourcesDetails, uniqueLoandReadinessInstanceId, userLoanReadinessPersonaDetails]);

    if (value !== index) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name, ">>>>name")
        console.log(value, ">>>>value");

        setFormData({ ...formData, [name]: value });
    };

    const handleFormToggle = () => {
        setIsFormOpen(!isFormOpen);
    };

    const handleAddEditButton = (rowData, action) => {
        if (action === "edit") {
            console.log(rowData, ">>>>rowData on handleEdit exprt consult");
            setIsFormOpen(true);
            setFormData(rowData);
            setIsEdit(true);
            setIsModalOpen(true)
        } else if (action === "add") {
            console.log(rowData, ">>>>rowData on handleEdit exprt consult");
            setIsFormOpen(true);
            setFormData(rowData);
            setIsEdit(false);
            setIsModalOpen(true)
        }

    }

    const handleUpdateButtonClick = (formData) => {
        const cibilScore = formData['Credit Score (CIBIL)'];
        const cibilNumber = Number(cibilScore);

        // 1. Check if it's a whole number
        if (!Number.isInteger(cibilNumber)) {
            toast("CIBIL score must be a whole number with no decimals", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        // 2. Check if it’s within the valid range (300–900)
        if (cibilNumber < 300 || cibilNumber > 900) {
            toast("CIBIL score must be between 300 to 900", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        } else if (!formData["nResourceInstanceId"]) {
            toast(String("Resource-ID is required"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsModalOpen(false)
        } else {
            const {
                nResourceInstanceId,
                "Net Profit Margin": netProfitMargin,
                "Existing Loan - (if any Amount, Type and Bank)": existingLoan,
                "Type of Bank Account": typeBankAcc,
                "Financial Reports(ITR, B/S)": financialReport,
                "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": businessEntity,
                "Credit Score (CIBIL)": creditScore,
                "Quotation Documents": quotationDoc,
                "Guarantor details": guaranteerDetail,
                "Collateral": collateral,
                "Receivable": receivable,
                "Payables": payables,
                "Loan Amount Required": loanAmmountReq,
                "Required Type of Loan(Term Loan/Cash Credit/ Composite)": reqTypeLoan,
                "Loan Purpose ( Mention distribution if composite)": loanPurpose,
                "Loan Application status": loanApplocationStatus,
                "Application status reasoning": appLicationStatusReasoning,
                "Services Availed(BLRP phase I / BLRP phase II )": serviceAvailed,
                "Key Recommendations": keyRecomm,
                Learnings,
                Challenges,
                "BLRP phase I / BLRP phase II report links": blrpRepLink,
                "Product Catalog Links": prodCatLink,
                ...remFormData
            } = formData

            handleUpdatePersonaDetail(
                {
                    "Type": "Business_Loan_Readiness_Program",
                    "subType": "Business Loan Readiness Program",
                    "nResourceInstanceId": nResourceInstanceId,
                    fields: {
                        "Net Profit Margin": netProfitMargin,
                        "Existing Loan - (if any Amount, Type and Bank)": existingLoan,
                        "Type of Bank Account": typeBankAcc,
                        "Financial Reports(ITR, B/S)": financialReport,
                        "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": businessEntity,
                        "Credit Score (CIBIL)": creditScore,
                        "Quotation Documents": quotationDoc,
                        "Guarantor details": guaranteerDetail,
                        "Collateral": collateral,
                        "Receivable": receivable,
                        "Payables": payables,
                        "Loan Amount Required": loanAmmountReq,
                        "Required Type of Loan(Term Loan/Cash Credit/ Composite)": reqTypeLoan,
                        "Loan Purpose ( Mention distribution if composite)": loanPurpose,
                        "Loan Application status": loanApplocationStatus,
                        "Application status reasoning": appLicationStatusReasoning,
                        "Services Availed(BLRP phase I / BLRP phase II )": serviceAvailed,
                        "Key Recommendations": keyRecomm,
                        Learnings,
                        Challenges,
                        "BLRP phase I / BLRP phase II report links": blrpRepLink,
                        "Product Catalog Links": prodCatLink,
                    }
                }
            );

            setFormData(initialFormData)
            setIsEdit(false)
            setIsModalOpen(false)
        }
    }


    const submitBusinessLoanPersonaForm = () => {

        // if (formData['Credit Score (CIBIL)'] < 700 || formData['Credit Score (CIBIL)'] > 900) {
        //     toast("Credit score should be between 700 and 900", {
        //         autoClose: 5000,
        //         type: toast.TYPE.ERROR,
        //     });
        //     return;
        // } else {
            const cibilScore = formData['Credit Score (CIBIL)'];
            const cibilNumber = Number(cibilScore);
            
            // 1. Check if it's a whole number (integer)
            if (!Number.isInteger(cibilNumber)) {
                toast("CIBIL score must be a whole number with no decimals", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            // 2. Check if it’s within the valid range (300–900)
            if (cibilNumber < 300 || cibilNumber > 900) {
                toast("CIBIL score must be between 300 to 900", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }else{
            const {
                nResourceInstanceId,
                "Net Profit Margin": netProfitMargin,
                "Existing Loan - (if any Amount, Type and Bank)": existingLoan,
                "Type of Bank Account": typeBankAcc,
                "Financial Reports(ITR, B/S)": financialReport,
                "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": businessEntity,
                "Credit Score (CIBIL)": creditScore,
                "Quotation Documents": quotationDoc,
                "Guarantor details": guaranteerDetail,
                "Collateral": collateral,
                "Receivable": receivable,
                "Payables": payables,
                "Loan Amount Required": loanAmmountReq,
                "Required Type of Loan(Term Loan/Cash Credit/ Composite)": reqTypeLoan,
                "Loan Purpose ( Mention distribution if composite)": loanPurpose,
                "Loan Application status": loanApplocationStatus,
                "Application status reasoning": appLicationStatusReasoning,
                "Services Availed(BLRP phase I / BLRP phase II )": serviceAvailed,
                "Key Recommendations": keyRecomm,
                Learnings,
                Challenges,
                "BLRP phase I / BLRP phase II report links": blrpRepLink,
                "Product Catalog Links": prodCatLink,
                ...remFormData
            } = formData

            console.log(remFormData, ">>>>remFormData in loadn readiness")
            const data = {
                "Type": 'Business_Loan_Readiness_Program',
                "subType": "Business Loan Readiness Program",
                "nResourceInstanceId": nResourceInstanceId,
                fields: {
                    "Net Profit Margin": netProfitMargin,
                    "Existing Loan - (if any Amount, Type and Bank)": existingLoan,
                    "Type of Bank Account": typeBankAcc,
                    "Financial Reports(ITR, B/S)": financialReport,
                    "Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)": businessEntity,
                    "Credit Score (CIBIL)": creditScore,
                    "Quotation Documents": quotationDoc,
                    "Guarantor details": guaranteerDetail,
                    "Collateral": collateral,
                    "Receivable": receivable,
                    "Payables": payables,
                    "Loan Amount Required": loanAmmountReq,
                    "Required Type of Loan(Term Loan/Cash Credit/ Composite)": reqTypeLoan,
                    "Loan Purpose ( Mention distribution if composite)": loanPurpose,
                    "Loan Application status": loanApplocationStatus,
                    "Application status reasoning": appLicationStatusReasoning,
                    "Services Availed(BLRP phase I / BLRP phase II )": serviceAvailed,
                    "Key Recommendations": keyRecomm,
                    Learnings,
                    Challenges,
                    "BLRP phase I / BLRP phase II report links": blrpRepLink,
                    "Product Catalog Links": prodCatLink,
                },
            };

            handleSubmitPersonaDetails(data);


            if (!isPersonaLoading) {
                // handleFormToggle(isPersonaFormOpen);
                handleFormToggle();
                setFormData(initialFormData)
                setIsModalOpen(false)
            }
        }
    };

    const renderForm = () => (
        <Box>
            {isPersonaLoading && <Spinner className="center-screen" />}
            {/* <TextField
                name="nResourceInstanceId"
                label="Resource Instance Id"
                // value={selectedResourceInstanceId}
                value={formData["nResourceInstanceId"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                // disabled={true}
            /> */}
            <TextField
                select
                name="nResourceInstanceId"
                label="Resource Instance Id"
                value={formData["nResourceInstanceId"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            style: {
                                maxHeight: 200, // height of dropdown
                                width: 300,     // width of dropdown
                            },
                        },
                    },
                }}
            >
                {uniqueLoandReadinessInstanceId?.map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Net Profit Margin"
                label="Net Profit Margin"
                value={formData["Net Profit Margin"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                type='number'
            />

            <TextField
                name="Existing Loan - (if any Amount, Type and Bank)"
                label="Existing Loan - (if any Amount, Type and Bank)"
                value={formData["Existing Loan - (if any Amount, Type and Bank)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"

            />

            {/* <TextField
        name="Type of Bank Account"
        label="Type of Bank Account"
        value={formData["Type of Bank Account"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Type of Bank Account"
                label="Type of Bank Account"
                value={formData["Type of Bank Account"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['Saving Account', 'Current Account'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            {/* <TextField
        name="Financial Reports"
        label="Financial Reports"
        value={formData["Financial Reports"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Financial Reports(ITR, B/S)"
                label="Financial Reports(ITR, B/S)"
                value={formData["Financial Reports(ITR, B/S)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['yes', 'no'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"
                label="Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"
                value={formData["Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            <TextField
                name="Credit Score (CIBIL)"
                label="Credit Score (CIBIL)"
                value={formData["Credit Score (CIBIL)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                type='number'
                inputProps={{ min: 700, max: 900 }}
            />

            {/* <TextField
        name="Quotation Documents"
        label="Quotation Documents"
        value={formData["Quotation Documents"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Quotation Documents"
                label="Quotation Documents"
                value={formData["Quotation Documents"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['yes', 'no'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            {/* <TextField
        name="Guarantor details"
        label="Guarantor details"
        value={formData["Guarantor details"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Guarantor details"
                label="Guarantor details"
                value={formData["Guarantor details"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['yes', 'no'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            {/* <TextField
        name="Collateral"
        label="Collateral"
        value={formData["Collateral"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Collateral"
                label="Collateral"
                value={formData["Collateral"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['yes', 'no'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            {/* <TextField
        name="Receivable"
        label="Receivable"
        value={formData["Receivable"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Receivable"
                label="Receivable"
                value={formData["Receivable"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['Cash', 'Digital Banking', 'Physical Banking', 'All of Above'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            {/* <TextField
        name="Payables"
        label="Payables"
        value={formData["Payables"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Payables"
                label="Payables"
                value={formData["Payables"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['Cash', 'Digital Banking', 'Physical Banking', 'All of Above'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Loan Amount Required"
                label="Loan Amount Required"
                value={formData["Loan Amount Required"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            {/* <TextField
        name="Required Type of Loan"
        label="Required Type of Loan"
        value={formData["Required Type of Loan"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Required Type of Loan(Term Loan/Cash Credit/ Composite)"
                label="Required Type of Loan(Term Loan/Cash Credit/ Composite)"
                value={formData["Required Type of Loan(Term Loan/Cash Credit/ Composite)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['Term Loan', 'Cash Credit', 'Composite'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Loan Purpose ( Mention distribution if composite)"
                label="Loan Purpose ( Mention distribution if composite)"
                value={formData["Loan Purpose ( Mention distribution if composite)"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            {/* <TextField
        name="Loan Application status"
        label="Loan Application status"
        value={formData["Loan Application status"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Loan Application status"
                label="Loan Application status"
                value={formData["Loan Application status"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['Not Applied', 'Applied', 'Approved', 'Not Approved'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Application status reasoning"
                label="Application status reasoning"
                value={formData["Application status reasoning"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            {/* <TextField
        name="Services Availed"
        label="Services Availed"
        value={formData["Services Availed"]}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      /> */}
            <TextField
                select
                name="Services Availed(BLRP phase I / BLRP phase II )"
                label="Services Availed(BLRP phase I / BLRP phase II )"
                value={formData["Services Availed(BLRP phase I / BLRP phase II )"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            >
                {['B1 Business Loan Readiness Intervention ', 'B2 Funding Proposal Creation'].map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>

            <TextField
                name="Key Recommendations"
                label="Key Recommendations"
                value={formData["Key Recommendations"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            <TextField
                name="Learnings"
                label="Learnings"
                value={formData["Learnings"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            <TextField
                name="Challenges"
                label="Challenges"
                value={formData["Challenges"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            <TextField
                name="BLRP phase I / BLRP phase II report links"
                label="BLRP phase I / BLRP phase II report links"
                value={formData["BLRP phase I / BLRP phase II report links"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />

            <TextField
                name="Product Catalog Links"
                label="Product Catalog Links"
                value={formData["Product Catalog Links"]}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
            />
        </Box>
    );



    const renderTable = () => (
        <TableContainer component={Paper} style={{ height: "405px", overflowY: 'auto' }}>
            <Table stickyHeader style={{ tableLayout: 'fixed', width: '250%' }}>
                <TableHead>
                    {/* Main Headings Row */}
                    <TableRow>
                        <TableCell /> {/* Resource Id */}

                        <TableCell /> {/* Net Profit Margin */}
                        <TableCell /> {/* Existing Loan */}
                        <TableCell /> {/* Bank Account */}
                        <TableCell colSpan={5} align="center">Compliance Status as per Business loan</TableCell>

                        <TableCell /> {/* Empty to align with colSpan */}

                        <TableCell colSpan={2} align="center">Use of Digital Payments</TableCell>

                        <TableCell /> {/* Loan Amount */}

                        <TableCell /> {/* Loan Type */}

                        <TableCell /> {/* Loan Purpose */}

                        <TableCell /> {/* Application Status */}

                        <TableCell /> {/* Reasoning */}

                        <TableCell /> {/* Services Availed */}

                        <TableCell /> {/* Recommendations */}

                        <TableCell /> {/* Learnings */}

                        <TableCell /> {/* Challenges */}

                        <TableCell /> {/* BLRP phase I / BLRP phase II report links */}
                        <TableCell /> {/* Product Catalog Links */}
                        {
                            !isTestimonialScreen && <TableCell />  // action column
                        }
                    </TableRow>

                    {/* Sub-Headings Row */}
                    <TableRow sx={{
                        height: 60,
                        borderBottom: '2px solid #ccc', // adds bottom border to the row
                    }}>
                        <TableCell>Resource Id</TableCell>

                        <TableCell>Net Profit Margin</TableCell>
                        <TableCell>Existing Loan - <br /> (if any Amount, Type and Bank)</TableCell>
                        <TableCell>Type of Bank Account</TableCell>

                        <TableCell>Financial Reports <br /> (ITR, B/S)</TableCell>
                        <TableCell>Business Entity Documents</TableCell>
                        <TableCell>Credit Score</TableCell>
                        <TableCell>Quotation Documents</TableCell>
                        <TableCell>Guarantor Details</TableCell>

                        <TableCell>Collateral</TableCell>

                        <TableCell>Receivable</TableCell>
                        <TableCell>Payables</TableCell>

                        <TableCell>Loan Amount Required</TableCell>
                        <TableCell>Required Type of Loan <br /> (Term Loan/Cash Credit/ Composite)</TableCell>

                        <TableCell>Loan Purpose <br /> ( Mention distribution if composite)</TableCell>

                        <TableCell>Loan Application Status</TableCell>

                        <TableCell>Application Status Reasoning</TableCell>

                        <TableCell>Services Availed <br /> (BLRP phase I / BLRP phase II )</TableCell>

                        <TableCell>Key Recommendations</TableCell>

                        <TableCell>Learnings</TableCell>

                        <TableCell>Challenges</TableCell>

                        <TableCell>BLRP <br /> (phase I / phase II) report links</TableCell>

                        <TableCell>Product Catalog Links</TableCell>
                        {
                            !isTestimonialScreen && <TableCell>Action</TableCell>
                        }
                    </TableRow>
                </TableHead>

                <TableBody>
                    {/* {
                        userLoanReadinessPersonaDetails ? (
                            userLoanReadinessPersonaDetails.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row["nResourceInstanceId"] ? row["nResourceInstanceId"] : "N/A"}</TableCell>
                                    <TableCell>{row["Net Profit Margin"] ? row["Net Profit Margin"] : ""}</TableCell>
                                    <TableCell>{row["Existing Loan - (if any Amount, Type and Bank)"] ? row["Existing Loan - (if any Amount, Type and Bank)"] : ""}</TableCell>
                                    <TableCell>{row["Type of Bank Account"] ? row["Type of Bank Account"] : "N/A"}</TableCell>
                                    <TableCell>{row["Financial Reports(ITR, B/S)"] ? row["Financial Reports(ITR, B/S)"] : "N/A"}</TableCell>
                                    <TableCell>{row["Business Entity related documents"] ? row["Business Entity related documents"] : "N/A"}</TableCell>
                                    <TableCell>{row["Credit Score (CIBIL)"] ? row["Credit Score (CIBIL)"] : "N/A"}</TableCell>
                                    <TableCell>{row["Quotation Documents"] ? row["Quotation Documents"] : "N/A"}</TableCell>
                                    <TableCell>{row["Guarantor details"] ? row["Guarantor details"] : "N/A"}</TableCell>
                                    <TableCell>{row["Collateral"] ? row["Collateral"] : "N/A"}</TableCell>
                                    <TableCell>{row["Receivable"] ? row["Receivable"] : "N/A"}</TableCell>
                                    <TableCell>{row["Payables"] ? row["Payables"] : "N/A"}</TableCell>
                                    <TableCell>{row["Loan Amount Required"] ? row["Loan Amount Required"] : "N/A"}</TableCell>
                                    <TableCell>{row["Required Type of Loan(Term Loan/Cash Credit/ Composite)"] ? row["Required Type of Loan(Term Loan/Cash Credit/ Composite)"] : "N/A"}</TableCell>
                                    <TableCell>{row["Loan Purpose ( Mention distribution if composite)"] ? row["Loan Purpose ( Mention distribution if composite)"] : "N/A"}</TableCell>
                                    <TableCell>{row["Loan Application status"] ? row["Loan Application status"] : "N/A"}</TableCell>
                                    <TableCell>{row["Application status reasoning"] ? row["Application status reasoning"] : "N/A"}</TableCell>
                                    <TableCell>{row["Services Availed(BLRP phase I / BLRP phase II )"] ? row["Services Availed(BLRP phase I / BLRP phase II )"] : "N/A"}</TableCell>
                                    <TableCell>{row["Key Recommendations"] ? row["Key Recommendations"] : "N/A"}</TableCell>
                                    <TableCell>{row["Learnings"] ? row["Learnings"] : "N/A"}</TableCell>
                                    <TableCell>{row["Challenges"] ? row["Challenges"] : "N/A"}</TableCell>
                                    <TableCell sx={{ maxWidth: 200, padding: 1 }}>
                                        {row["BLRP phase I / BLRP phase II report links"] ? (
                                            <a
                                                href={row["BLRP phase I / BLRP phase II report links"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", // optional: MUI primary link color
                                                    textDecoration: "underline", // optional: link styling
                                                }}
                                            >
                                                {row["BLRP phase I / BLRP phase II report links"]}
                                            </a>
                                        ) : (
                                            "N/A"
                                        )}
                                    </TableCell>

                                    <TableCell sx={{ maxWidth: 200, padding: 1 }}>
                                        {row["Product Catalog Links"] ? (
                                            <a
                                                href={row["Product Catalog Links"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", // optional: MUI primary link color
                                                    textDecoration: "underline", // optional: link styling
                                                }}
                                            >
                                                {row["Product Catalog Links"]}
                                            </a>
                                        ) : (
                                            "N/A"
                                        )}
                                    </TableCell>
                                    <TableCell><Button onClick={() => handleAddEditButton(row)}>Edit</Button></TableCell>

                                </TableRow>
                            ))
                        ) : <TableRow>
                            <TableCell colSpan={24} align="center">
                                No Data Found
                            </TableCell>
                        </TableRow>
                    } */}

                    {
                        allResourcePersonaDetails ? (
                            allResourcePersonaDetails.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["nResourceInstanceId"] ? row["nResourceInstanceId"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Net Profit Margin"] ? row["Net Profit Margin"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Existing Loan - (if any Amount, Type and Bank)"] ? row["Existing Loan - (if any Amount, Type and Bank)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Type of Bank Account"] ? row["Type of Bank Account"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Financial Reports(ITR, B/S)"] ? row["Financial Reports(ITR, B/S)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"] ? row["Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Credit Score (CIBIL)"] ? row["Credit Score (CIBIL)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Quotation Documents"] ? row["Quotation Documents"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Guarantor details"] ? row["Guarantor details"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Collateral"] ? row["Collateral"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Receivable"] ? row["Receivable"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Payables"] ? row["Payables"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Loan Amount Required"] ? row["Loan Amount Required"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Required Type of Loan(Term Loan/Cash Credit/ Composite)"] ? row["Required Type of Loan(Term Loan/Cash Credit/ Composite)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Loan Purpose ( Mention distribution if composite)"] ? row["Loan Purpose ( Mention distribution if composite)"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Loan Application status"] ? row["Loan Application status"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Application status reasoning"] ? row["Application status reasoning"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Services Availed(BLRP phase I / BLRP phase II )"] ? row["Services Availed(BLRP phase I / BLRP phase II )"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Key Recommendations"] ? row["Key Recommendations"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Learnings"] ? row["Learnings"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                    >{row["Challenges"] ? row["Challenges"] : ""}</TableCell>
                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                        sx={{ maxWidth: 200, padding: 1 }}>
                                        {row["BLRP phase I / BLRP phase II report links"] ? (
                                            <a
                                                href={row["BLRP phase I / BLRP phase II report links"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", // optional: MUI primary link color
                                                    textDecoration: "underline", // optional: link styling
                                                }}
                                            >
                                                {row["BLRP phase I / BLRP phase II report links"]}
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </TableCell>

                                    <TableCell
                                        style={{
                                            alignContent: "flex-start"
                                        }}
                                        sx={{ maxWidth: 200, padding: 1 }}>
                                        {row["sCatalogueUrl"] ? (
                                            <a
                                                href={row["sCatalogueUrl"]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: "block",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word",
                                                    textAlign: "justify",
                                                    color: "#1976d2", // optional: MUI primary link color
                                                    textDecoration: "underline", // optional: link styling
                                                }}
                                            >
                                                {row["sCatalogueUrl"]}
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </TableCell>
                                    {
                                        !isTestimonialScreen && (
                                            <TableCell
                                                style={{
                                                    alignContent: "flex-start"
                                                }}
                                            >
                                                {
                                                    row["isAlreadyPersonaExisting"] ? (
                                                        <Button onClick={() => handleAddEditButton(row, "edit")}>{"Edit"}</Button>
                                                    ) : (
                                                        <Button onClick={() => handleAddEditButton(row, "add")}>{"Add"}</Button>
                                                    )
                                                }
                                            </TableCell>
                                        )
                                    }

                                </TableRow>
                            ))
                        ) : <TableRow>
                            <TableCell colSpan={24} align="center">
                                No Data Found
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );

    const handleCancelForm = () => {
        setIsFormOpen(false);
        setIsEdit(false);
        setFormData(initialFormData)
        setIsModalOpen(false);
    }

    console.log(userLoanReadinessPersonaDetails, ">>>>userLoanReadinessPersonaDetails in load readiness persona table");
    console.log(loanReadinessResourcesOfUser, ">>>>loanReadinessResourcesOfUser");
    console.log(leftResourcesForAddingPersona, ">>>>>>>leftResourcesForAddingPersona in loan readiness");
    console.log(allResourcePersonaDetails, ">>>>>allResourcePersonaDetails in loan readiness");

    return (
        <Box style={{ padding: '16px' }} className={`${isPersonaLoading && "set-opacity"}`}>
            {isPersonaLoading && <Spinner className="center" />}
            <Typography variant="h6" style={{ fontWeight: 'bold', color: '#6D1B7B' }}>
                {title}
            </Typography>

            <Box>
                {/* {isFormOpen ? renderForm() : renderTable()} */}
                {/* {isPersonaFormOpen ? renderForm() : renderTable()} */}
                {renderTable()}
            </Box>

            {/* <Box>
                {
                    isFormOpen ? (
                        // isPersonaFormOpen ? (
                        <Box display="flex" justifyContent="flex-end" padding="0px 20px" style={{ gap: '20px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                // onClick={handleFormCancel}
                                // onClick={() => setIsFormOpen(false)}
                                onClick={() => handleCancelForm()}
                                style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                            >
                                Cancel
                            </Button>

                            {
                                !isEdit ? <Button
                                    variant="contained"
                                    color="primary"
                                    // onClick={handleFormToggle}
                                    onClick={submitBusinessLoanPersonaForm}
                                    style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                                >
                                    Submit
                                </Button> : <Button
                                    variant="contained"
                                    color="primary"
                                    // onClick={handleFormToggle}
                                    onClick={() => handleUpdateButtonClick(formData)}
                                    style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                                >
                                    Update
                                </Button>
                            }
                        </Box>
                    ) : (
                        <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleFormToggle}
                                style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                            >
                                Add New Persona Detail
                            </Button>
                        </Box>
                        // ""
                    )}
            </Box> */}

            {/* <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
                <Button
                    variant="contained"
                    color="primary"
                    // onClick={handleFormToggle}
                    onClick={() => setIsModalOpen(true)}
                    style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                    disabled={loanReadinessResourcesOfUser.length <= 0 || leftResourcesForAddingPersona.length <= 0}
                >
                    Add New Persona Detail
                </Button>
            </Box> */}

            <FormModalLoanReadiness
                open={isModalOpen}
                // onClose={() => setIsModalOpen(false)}
                onClose={() => handleCancelForm()}
                isPersonaLoading={isPersonaLoading}
                formData={formData}
                handleInputChange={handleInputChange}
                uniqueLoandReadinessInstanceId={uniqueLoandReadinessInstanceId}
                isEdit={isEdit}
                handleUpdateButtonClick={handleUpdateButtonClick}
                submitBusinessLoanPersonaForm={submitBusinessLoanPersonaForm}
                loanReadinessAlreadyFilledPersonaInstanceId={loanReadinessAlreadyFilledPersonaInstanceId}
            />
        </Box>
    );
}
